import type { ChangeTrackingSource } from '@typeDefinitions/changeTrackingTypes';
import { buildChangeTrackingRequestConfig } from '@changeTracking/utils/buildChangeTrackingHeaders';

export const buildSourceTrackingConfig = (source?: ChangeTrackingSource) =>
  source === undefined ? undefined : buildChangeTrackingRequestConfig([source]);
